"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newDeleteCreditCard = exports.newShowCreditCardForm = exports.loadCreditCards = exports.deleteEBillingMailAddress = exports.setEBillingMailAddress = exports.setDeviantBillingAddress = exports.activateAccount = exports.requestSignUp = exports.signUp = exports.serverValidationFailed = exports.setFormConfigurationValues = exports.loadFormConfiguration = exports.newEnsureUserLoggedIn = exports.newSetLoginState = exports.newLogoutAndRedirect = exports.newLoginAndRedirect = exports.dispatchCaptchaSolved = exports.login = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _redux = require("../util/redux.js");

var _store = require("../config/store.js");

var _store2 = require("./store.js");

var _actions = require("../window/actions.js");

var _store3 = require("../l10n/store.js");

var _actions2 = require("../routing/actions.js");

var _actions3 = require("../rent_contracts/actions.js");

var login = function login(_ref) {
  var username = _ref.username,
      password = _ref.password,
      rentContractId = _ref.rentContractId,
      captchaToken = _ref.captchaToken,
      afterLoginAction = _ref.afterLoginAction;
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(dispatch, getState, context) {
      var isSuccessful;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              isSuccessful = false;
              _context2.next = 4;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "USER/LOGIN",
                loadPayload: function () {
                  var _loadPayload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                    var _yield$Promise$all, _yield$Promise$all2, profile;

                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return context.api.user.login({
                              username: username,
                              password: password,
                              captchaToken: captchaToken
                            });

                          case 3:
                            _context.next = 9;
                            break;

                          case 5:
                            _context.prev = 5;
                            _context.t0 = _context["catch"](0);
                            isSuccessful = false;
                            throw _context.t0;

                          case 9:
                            _context.next = 11;
                            return Promise.all([context.api.user.getProfile(), rentContractId ? dispatch((0, _actions3.updateRentContractAfterLogin)(rentContractId)) : Promise.resolve(), afterLoginAction ? dispatch(afterLoginAction()) : Promise.resolve()]);

                          case 11:
                            _yield$Promise$all = _context.sent;
                            _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 1);
                            profile = _yield$Promise$all2[0];
                            isSuccessful = true;
                            return _context.abrupt("return", {
                              loggedIn: true,
                              profile: profile
                            });

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 5]]);
                  }));

                  function loadPayload() {
                    return _loadPayload.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 4:
              return _context2.abrupt("return", {
                success: isSuccessful
              });

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0.type === "LOGIN_INVALID")) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return", {
                success: false
              });

            case 11:
              throw _context2.t0;

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.login = login;

var dispatchCaptchaSolved = function dispatchCaptchaSolved() {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(dispatch) {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch({
                type: "USER/CAPTCHA_SOLVED",
                payload: {}
              });

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.dispatchCaptchaSolved = dispatchCaptchaSolved;

var newLoginAndRedirect = function newLoginAndRedirect(_ref4) {
  var defaultRedirectLocation = _ref4.defaultRedirectLocation,
      afterLoginAction = _ref4.afterLoginAction;
  return function (_ref5) {
    var username = _ref5.username,
        password = _ref5.password,
        rentContractId = _ref5.rentContractId,
        captchaToken = _ref5.captchaToken;
    return /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(dispatch, getState, context) {
        var state, _ref7, redirectTo;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = context.history.location.state;
                _ref7 = state || {}, redirectTo = _ref7.redirectTo;
                _context4.next = 4;
                return dispatch(login({
                  username: username,
                  password: password,
                  rentContractId: rentContractId,
                  captchaToken: captchaToken,
                  afterLoginAction: afterLoginAction
                }));

              case 4:
                if ((0, _store2.getLoggedIn)(getState())) {
                  dispatch((0, _actions2.redirect)(redirectTo || defaultRedirectLocation((0, _store2.getUserProfile)(getState()))));
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5, _x6, _x7) {
        return _ref6.apply(this, arguments);
      };
    }();
  };
};

exports.newLoginAndRedirect = newLoginAndRedirect;

var newLogoutAndRedirect = function newLogoutAndRedirect(defaultRedirectPath) {
  return function () {
    return /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(dispatch, getState, context) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return context.api.user.logout();

              case 2:
                _context5.next = 4;
                return context.api.l10n.setLocale({
                  locale: (0, _store3.getCurrentLocale)(getState())
                });

              case 4:
                dispatch({
                  type: "USER/USER_LOGGED_OUT"
                });
                dispatch((0, _actions2.redirectExternal)(defaultRedirectPath));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x8, _x9, _x10) {
        return _ref8.apply(this, arguments);
      };
    }();
  };
};

exports.newLogoutAndRedirect = newLogoutAndRedirect;

var newSetLoginState = function newSetLoginState() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    return /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(dispatch, getState, context) {
        var _options$onSessionExp, onSessionExpired, wasLoggedIn, profile, isLoggedIn;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _options$onSessionExp = options.onSessionExpired, onSessionExpired = _options$onSessionExp === void 0 ? function () {} : _options$onSessionExp;
                wasLoggedIn = (0, _store2.getLoggedIn)(getState());
                _context6.next = 4;
                return context.api.user.getProfile();

              case 4:
                profile = _context6.sent;
                dispatch({
                  type: "USER/LOGIN_LOADED",
                  payload: {
                    loggedIn: Boolean(profile),
                    profile: profile
                  }
                });
                isLoggedIn = (0, _store2.getLoggedIn)(getState());

                if (!(wasLoggedIn && !isLoggedIn)) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 10;
                return onSessionExpired(dispatch, getState, context);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x11, _x12, _x13) {
        return _ref9.apply(this, arguments);
      };
    }();
  };
};

exports.newSetLoginState = newSetLoginState;

var newEnsureUserLoggedIn = function newEnsureUserLoggedIn() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    return /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(dispatch, getState, context) {
        var _options$setLoginStat, setLoginState;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _options$setLoginStat = options.setLoginState, setLoginState = _options$setLoginStat === void 0 ? newSetLoginState() : _options$setLoginStat;
                _context7.next = 3;
                return dispatch(setLoginState());

              case 3:
                if ((0, _store2.getLoggedIn)(getState())) {
                  _context7.next = 5;
                  break;
                }

                throw new Error("User is not logged in");

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x14, _x15, _x16) {
        return _ref10.apply(this, arguments);
      };
    }();
  };
};

exports.newEnsureUserLoggedIn = newEnsureUserLoggedIn;

var loadFormConfiguration = function loadFormConfiguration(groupName) {
  return /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "USER/FORM_CONFIGURATION",
                loadPayload: function () {
                  var _loadPayload2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
                    return _regenerator["default"].wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.t0 = groupName;
                            _context8.next = 3;
                            return context.api.user.getFormConfiguration({
                              groupName: groupName
                            });

                          case 3:
                            _context8.t1 = _context8.sent;
                            return _context8.abrupt("return", {
                              groupName: _context8.t0,
                              formConfiguration: _context8.t1
                            });

                          case 5:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  function loadPayload() {
                    return _loadPayload2.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x17, _x18, _x19) {
      return _ref11.apply(this, arguments);
    };
  }();
};

exports.loadFormConfiguration = loadFormConfiguration;

var setFormConfigurationValues = function setFormConfigurationValues(groupName, values) {
  return {
    type: "USER/FORM_CONFIGURATION_VALUES",
    payload: {
      groupName: groupName,
      values: values
    }
  };
};

exports.setFormConfigurationValues = setFormConfigurationValues;

var serverValidationFailed = function serverValidationFailed(groupName, values, errors) {
  return {
    type: "USER/SERVER_VALIDATION_FAILED",
    payload: {
      groupName: groupName,
      values: values,
      errors: errors
    }
  };
};

exports.serverValidationFailed = serverValidationFailed;

var signUp = function signUp(formValues) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "USER/SIGN_UP",
                loadPayload: function loadPayload() {
                  return context.api.user.signUp(formValues);
                }
              }));

            case 2:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x20, _x21, _x22) {
      return _ref12.apply(this, arguments);
    };
  }();
};

exports.signUp = signUp;

var requestSignUp = function requestSignUp(formValues) {
  return /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "USER/SIGN_UP",
                loadPayload: function loadPayload() {
                  return context.api.user.requestSignUp(formValues);
                }
              }));

            case 2:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x23, _x24, _x25) {
      return _ref13.apply(this, arguments);
    };
  }();
};

exports.requestSignUp = requestSignUp;

var activateAccount = function activateAccount(activationToken, rentContractToken) {
  return /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(dispatch, getState, context) {
      var _yield$context$api$us, regToken, rentContractId;

      return _regenerator["default"].wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return context.api.user.activateAccount({
                activationToken: activationToken,
                rentContractToken: rentContractToken
              });

            case 2:
              _yield$context$api$us = _context13.sent;
              regToken = _yield$context$api$us.regToken;
              rentContractId = _yield$context$api$us.rentContractId;
              _context13.next = 7;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "USER/LOGIN",
                loadPayload: function () {
                  var _loadPayload3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
                    var profile;
                    return _regenerator["default"].wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return context.api.user.loginWithToken({
                              regToken: regToken
                            });

                          case 2:
                            _context12.next = 4;
                            return context.api.user.getProfile();

                          case 4:
                            profile = _context12.sent;
                            return _context12.abrupt("return", {
                              loggedIn: true,
                              profile: profile
                            });

                          case 6:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12);
                  }));

                  function loadPayload() {
                    return _loadPayload3.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 7:
              return _context13.abrupt("return", {
                rentContractId: rentContractId
              });

            case 8:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x26, _x27, _x28) {
      return _ref14.apply(this, arguments);
    };
  }();
};

exports.activateAccount = activateAccount;

var setDeviantBillingAddress = function setDeviantBillingAddress(data) {
  return /*#__PURE__*/function () {
    var _ref15 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return context.api.user.setDeviantBillingAddress(data);

            case 2:
              _context15.next = 4;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "USER/LOGIN",
                loadPayload: function () {
                  var _loadPayload4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
                    return _regenerator["default"].wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            _context14.next = 2;
                            return context.api.user.getProfile();

                          case 2:
                            _context14.t0 = _context14.sent;
                            return _context14.abrupt("return", {
                              loggedIn: true,
                              profile: _context14.t0
                            });

                          case 4:
                          case "end":
                            return _context14.stop();
                        }
                      }
                    }, _callee14);
                  }));

                  function loadPayload() {
                    return _loadPayload4.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 4:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x29, _x30, _x31) {
      return _ref15.apply(this, arguments);
    };
  }();
};

exports.setDeviantBillingAddress = setDeviantBillingAddress;

var setEBillingMailAddress = function setEBillingMailAddress(eBillingMailAddress) {
  return /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "USER/LOGIN",
                loadPayload: function () {
                  var _loadPayload5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
                    return _regenerator["default"].wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            _context16.next = 2;
                            return context.api.user.setEBillingMailAddress({
                              eBillingMailAddress: eBillingMailAddress
                            });

                          case 2:
                            _context16.t0 = _context16.sent;
                            return _context16.abrupt("return", {
                              loggedIn: true,
                              profile: _context16.t0
                            });

                          case 4:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16);
                  }));

                  function loadPayload() {
                    return _loadPayload5.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 2:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function (_x32, _x33, _x34) {
      return _ref16.apply(this, arguments);
    };
  }();
};

exports.setEBillingMailAddress = setEBillingMailAddress;

var deleteEBillingMailAddress = function deleteEBillingMailAddress() {
  return /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return dispatch((0, _redux.asyncAction)({
                typePrefix: "USER/LOGIN",
                loadPayload: function () {
                  var _loadPayload6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18() {
                    return _regenerator["default"].wrap(function _callee18$(_context18) {
                      while (1) {
                        switch (_context18.prev = _context18.next) {
                          case 0:
                            _context18.next = 2;
                            return context.api.user.deleteEBillingMailAddress();

                          case 2:
                            _context18.t0 = _context18.sent;
                            return _context18.abrupt("return", {
                              loggedIn: true,
                              profile: _context18.t0
                            });

                          case 4:
                          case "end":
                            return _context18.stop();
                        }
                      }
                    }, _callee18);
                  }));

                  function loadPayload() {
                    return _loadPayload6.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 2:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    return function (_x35, _x36, _x37) {
      return _ref17.apply(this, arguments);
    };
  }();
};

exports.deleteEBillingMailAddress = deleteEBillingMailAddress;

var loadCreditCards = function loadCreditCards() {
  return /*#__PURE__*/function () {
    var _ref18 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.t0 = dispatch;
              _context20.next = 3;
              return context.api.user.getCreditCards();

            case 3:
              _context20.t1 = _context20.sent;
              _context20.t2 = {
                creditCards: _context20.t1
              };
              _context20.t3 = {
                type: "USER/CREDIT_CARDS_LOADED",
                payload: _context20.t2
              };
              (0, _context20.t0)(_context20.t3);

            case 7:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    return function (_x38, _x39, _x40) {
      return _ref18.apply(this, arguments);
    };
  }();
};

exports.loadCreditCards = loadCreditCards;

var newShowCreditCardForm = function newShowCreditCardForm() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return /*#__PURE__*/function () {
      var _ref19 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21(dispatch, getState, context) {
        var _options$ensureUserLo, ensureUserLoggedIn, amsBaseUrl, url, title, params;

        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _options$ensureUserLo = options.ensureUserLoggedIn, ensureUserLoggedIn = _options$ensureUserLo === void 0 ? newEnsureUserLoggedIn() : _options$ensureUserLo;
                amsBaseUrl = (0, _store.getAmsBaseUrl)(getState());
                url = "".concat(amsBaseUrl, "/v1.1/telecash/redirect");
                title = "Credit Card";
                params = {
                  width: "850",
                  height: "600",
                  left: "300",
                  top: "200",
                  resizable: "yes",
                  scrollbars: "yes"
                };
                _context21.next = 7;
                return dispatch((0, _actions.openPopup)(url, title, params, interval));

              case 7:
                _context21.next = 9;
                return dispatch(ensureUserLoggedIn());

              case 9:
                _context21.next = 11;
                return dispatch(loadCreditCards());

              case 11:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      return function (_x41, _x42, _x43) {
        return _ref19.apply(this, arguments);
      };
    }();
  };
};

exports.newShowCreditCardForm = newShowCreditCardForm;

var newDeleteCreditCard = function newDeleteCreditCard() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (creditCardId) {
    return /*#__PURE__*/function () {
      var _ref20 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22(dispatch, getState, context) {
        var _options$ensureUserLo2, ensureUserLoggedIn;

        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _options$ensureUserLo2 = options.ensureUserLoggedIn, ensureUserLoggedIn = _options$ensureUserLo2 === void 0 ? newEnsureUserLoggedIn() : _options$ensureUserLo2;
                _context22.next = 3;
                return dispatch(ensureUserLoggedIn());

              case 3:
                _context22.next = 5;
                return dispatch((0, _redux.asyncAction)({
                  typePrefix: "USER/DELETE_CREDIT_CARD",
                  loadPayload: function loadPayload() {
                    return context.api.user.deleteCreditCard({
                      creditCardId: creditCardId
                    });
                  }
                }));

              case 5:
                _context22.next = 7;
                return dispatch(loadCreditCards());

              case 7:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      return function (_x44, _x45, _x46) {
        return _ref20.apply(this, arguments);
      };
    }();
  };
};

exports.newDeleteCreditCard = newDeleteCreditCard;